import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Vdp from '../Vdp';
import useSelectedTrade from '../../_shared/hooks/trade/useSelectedTrade';

import {
  StyledVdpContainer,
  StyledInvalidMiniVdp,
  StyledNothingSelected,
  StyledCardClickIcon,
  StyledNothingSelectedHeading,
  StyledNothingSelectedSubheading
} from './Styles';

const MiniVdp = () => {
  const [tradeContext, tradeState] = useSelector(
    state => [
      state?.ui?.nav?.primary?.context,
      state?.ui?.nav?.secondary?.context
    ],
    shallowEqual
  );
  const selectedTrade = useSelectedTrade(tradeState);
  const { id: tradeId, isAuctionEnded } = selectedTrade || {};
  return tradeId ? (
    <StyledVdpContainer
      id="miniVdpContainer"
      tradeState={tradeState}
      key={`miniVdpTrade-${tradeId}`}
    >
      <Vdp tradeId={tradeId} tradeContext={tradeContext} />
      {isAuctionEnded && <StyledInvalidMiniVdp />}
    </StyledVdpContainer>
  ) : (
    <StyledVdpContainer
      id="miniVdpContainer"
      tradeState={tradeState}
      key="miniVdpNothingSelected"
    >
      <StyledNothingSelected>
        <StyledCardClickIcon />
        <StyledNothingSelectedHeading>
          <FormattedMessage id="mini.vdp.nothing.selected.heading" />
        </StyledNothingSelectedHeading>
        <StyledNothingSelectedSubheading>
          <FormattedMessage id="mini.vdp.nothing.selected.subheading" />
        </StyledNothingSelectedSubheading>
      </StyledNothingSelected>
    </StyledVdpContainer>
  );
};

export default MiniVdp;
